import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { roleColor } from '../../../../lib/reportRoleColors';
import { EditorialSubsection } from '../../report/editorial';

/**
 * Year-1 CAPEX/OPEX — GAP: no dedicated cost field on the interconnection
 * schema. Surface the edgeDeployment narrative when present (often contains
 * cost language) plus a muted pointer at the recommendations list. Gen-side
 * need: a year-1 capex/opex figure set on `interconnectionAnalysis`.
 */
export const CapexOpexSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const edge = report.interconnectionAnalysis?.edgeDeployment;
  const hasEdge = typeof edge === 'string' && edge.trim().length > 0;
  const hasRecs = (report.interconnectionAnalysis?.recommendations ?? [])
    .some((r) => r.trim().length > 0);
  return (
    <SectionShell label={label} hasData={hasEdge || hasRecs}>
      {hasEdge && (
        <EditorialSubsection theme={theme} label="Edge deployment">{edge}</EditorialSubsection>
      )}
      {hasRecs && (
        <p className="text-xs italic m-0" style={{ color: roleColor(theme, 'muted') }}>
          Cost-bearing actions appear in the recommendations section.
        </p>
      )}
    </SectionShell>
  );
};
